import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import ERidesBigPromise from '../../client_customizations/components/ERides/components/ERidesBigPromise';
import ERidesFAQ from '../../client_customizations/components/ERides/components/ERidesFAQ';
import ERidesRebateCards from '../../client_customizations/components/ERidesRebateCards/ERidesRebateCards';
import AustinBikeMapFAQ from '../../client_customizations/components/AustinBikeMap/AustinBikeMapFAQ';

import { FormattedMessage } from 'react-intl';

const ERides = ({ eRidesBannerImage, ip, uuid }) => {
  useEffect(() => {
    document.title = process.env.REACT_APP_PAGES_HOME_TITLE;
  });

  const renderDetails = (
    <>
      <ERidesRebateCards />
      <ERidesFAQ />
      <AustinBikeMapFAQ />
    </>
  );

  return (
    <>
      <ERidesBigPromise eRidesBannerImage={eRidesBannerImage} />
      {renderDetails}
      <div className="bottom-cta-container">
        <div className="container">
          <div className="bottom-cta column">
            <h2>
              <FormattedMessage
                id="erides.readyToRide.title"
                defaultMessage="Ready to Ride?"
              />
            </h2>
            <p>
              <FormattedMessage
                id="erides.readyToRide.description"
                defaultMessage="Start saving today. Find an {link} and apply for your rebate."
                values={{
                  link: (
                    <a
                      href="https://austinenergy.com/green-power/plug-in-austin/more-ways-to-go-electric/e-ride-rebate#dealerships"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FormattedMessage
                        id="erides.readyToRide.link"
                        defaultMessage="eligible dealer"
                      />
                    </a>
                  ),
                }}
              />
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default ERides;

ERides.propTypes = {
  eRidesBannerImage: PropTypes.string,
  ip: PropTypes.string,
  uuid: PropTypes.string,
};
